exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: diablo) {\n.dof-board-header[data-v-e4ffb9be] {\n    background-color: #101315;\n}\n.dof-board-header-title[data-v-e4ffb9be] {\n    color: #cfcfd0;\n}\n.dof-board-header-subtitle[data-v-e4ffb9be] {\n    color: #a2a4a5;\n}\n}", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-board/diablo.css"],"names":[],"mappings":";AAAA;AACE;IACE,0BAA0B;CAC3B;AACD;IACE,eAAe;CAChB;AAED;IACE,eAAe;CAChB;CACF","file":"diablo.css","sourcesContent":["@media screen and (weex-theme: diablo) {\n  .dof-board-header {\n    background-color: #101315;\n  }\n  .dof-board-header-title {\n    color: #cfcfd0;\n  }\n  \n  .dof-board-header-subtitle {\n    color: #a2a4a5;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4ffb9be","scoped":true,"hasInlineConfig":false}!./packages/dof-board/diablo.css
// module id = 265
// module chunks = 0 1